import { lazy, Suspense, useEffect, useState } from "react";

import { buildMetadata } from "@/lib/seo";

/**
 * /admin.
 *
 * Everything here is behind a session and must never appear in server-rendered
 * HTML, so the route renders nothing on the server and mounts the panel after
 * hydration. The bundle is lazy as well, so a visitor who never opens this page
 * never downloads it.
 *
 * robots.txt disallows /admin too. That is not the security boundary, it is
 * only tidiness: the boundary is the API, which refuses every admin request
 * without a valid session cookie.
 */
const AdminApp = lazy(() => import("@/admin/AdminApp").then((m) => ({ default: m.AdminApp })));

export const meta = () =>
  buildMetadata({
    title: "Staff sign-in",
    description: "Content administration for HISCUS staff.",
    path: "/admin",
  });

export function AdminPage() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return (
      <div className="container-page py-24">
        <h1 style={{ fontSize: "var(--step-h2)" }}>Staff sign-in</h1>
        <p className="mt-4 text-muted">Loading the content tools.</p>
      </div>
    );
  }

  return (
    <Suspense fallback={<div className="container-page py-24 text-muted">Loading the content tools.</div>}>
      <AdminApp />
    </Suspense>
  );
}
